import React from "react";
import { Link } from "react-router-dom";


const Footer = ({ data }) => {
    
  const {
    profile = {},
    currentOffice = {},
  
  } = data || {};

  const {
    title = "Hon.",
    first_name = "",
    middle_name = "",
    last_name = "",
    initials = "AF",
   full_name = "Hon. Akindele Femi Olanrewaju",
    motto = "PEOPLE • PURPOSE • PROGRESS",
  } = profile;

  const {
    position = "Member",
    office = "Ekiti State House of Assembly",
    roleDescription = "",
  } = currentOffice;


  const facebook =  profile.facebook   ?  profile.facebook   :  " " ;
  const instagram  =  profile.instagram   ? profile.instagram  :  " "  ;
  const youtube  = profile.youtube  ? profile.youtube:  " " ;  
  const x  =  profile.x  ?   profile.x  :  " ";

 

  const socialLinks = [
    {
      label: "Facebook",
      href: facebook,
    },
    {
      label: "Instagram",
      href: instagram,
    },
    {
      label: "YouTube",
      href: youtube,
    },
    {
      label: "X / Twitter",
      href: x,
    },
  ];

  return (
    <footer className="footer">

      <div className="container">

        <div className="footer-main">

          {/* BRAND */}
          <div className="footer-brand">

            <div className="brand">

              <div
                className="brand-mark"
                aria-hidden="true"
              >
                <span>
                  {initials}
                </span>
              </div>

              <div className="brand-text">

                <strong>
                  {title}{" "}
                  {first_name.toUpperCase()}
                </strong>

                <small>
                  {middle_name.toUpperCase()}{" "}
                  {last_name.toUpperCase()}
                </small>

              </div>

            </div>

            <p>
              {position},{" "}
              {office}
              {roleDescription && (
                <>
                  .{" "}
                  {roleDescription}.
                </>
              )}
            </p>

            <div className="footer-motto">
              {motto}
            </div>

          </div>

          {/* EXPLORE */}
          <div className="footer-column">

            <h4>Explore</h4>

            <Link to="/about">
              About
            </Link>

            <Link to="/careertimeline">
              Career Timeline
            </Link>

            <Link to="/constituency">
              Constituency
            </Link>

            <Link to="/projects">
              Projects
            </Link>

          </div>

          {/* INFORMATION */}
          <div className="footer-column">

            <h4>Information</h4>

            <Link to="/news">
              News &amp; Updates
            </Link>

            <Link to="/media">
              Media Centre
            </Link>

            <Link to="/contact">
              Contact Office
            </Link>

          {/*   <Link to="/contact">
              Submit Concern
            </Link> */}

          </div>

          {/* SOCIAL */}
          <div className="footer-column">

            <h4>Follow</h4>

            {socialLinks.map(
              ({ label, href }) => {
                if (!href || href === "#") {
                  return null;
                }

                return (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {label}
                  </a>
                );
              }
            )}

          </div>

        </div>

        {/* FOOTER BOTTOM */}
        <div className="footer-bottom">

          <span>
            © {new Date().getFullYear()}{" "}
            {full_name}. All Rights Reserved.
          </span>

          <span>
            {position},{" "}
            {office}
          </span>

        </div>

      </div>

    </footer>
  );
};

export default Footer;